// external
import React, { useContext, useState } from "react";
import { toast } from "react-toastify";

// components
import CustomSelect from "components/partials/custom-select/custom-select";
import Heading from "components/partials/heading/heading";
import CustomButton from "components/partials/custom-button/custom-button";

// api
import apiRoot from "api/apiRoot";

// state managing/security
import { FaoRegimeContext } from "context/FaoRegimeContext";

// css/styling
import { STYLES, mergeStyles } from "../constants/styles.constants";

const customSelectStyles = {
  ...STYLES.select,
  control: (provided, state) => ({
    ...STYLES.select.control(provided, state),
    width: "300px", // override width here
  }),
};

const SCHEMA_OPTIONS = [
  { value: "fact", label: "fact" },
  { value: "dimension", label: "dimension" },
  { value: "lkp", label: "lkp" },
];

function RegimeNewColumn({ setPopupOpen }) {
  const [tableOptions, setTableOptions] = useState([]);
  const { columnOptions, setColumnOptions, compare } =
    useContext(FaoRegimeContext);
  const [existingColumns, setExistingColumns] = useState([]);
  const [schema, setSchema] = useState("");
  const [table, setTable] = useState("");
  const [column, setColumn] = useState("");

  const handleSchemaChange = async (selected) => {
    setSchema(selected.value);
    const toastMessages = {
      pending: `Fetching tables for schema: ${selected.value}`,
      success: `SUCCESS - tables for schema: ${selected.value} Found`,
      error: "FAILED - Please Reach out to Support for Assistance",
    };
    try {
      setExistingColumns([]);
      setTableOptions([]); // Clear previous options
      setTable("");
      setColumn("");
      // setValue("table", "");
      const promise = apiRoot.get(
        `/api/fao-regime/tablenames/${selected.value}`
      );
      const res = await toast.promise(promise, toastMessages);
      const newTableOptions = res.data.map((item) => ({
        value: item[0],
        label: item[0],
      }));
      newTableOptions.sort(compare);
      setTableOptions(newTableOptions); // Update state with new options
    } catch (error) {
      console.log(error);
    }
  };

  const handleTableChange = async (selected) => {
    setTable(selected.value);
    const toastMessages = {
      pending: `Fetching columns for table: ${selected.value}`,
      success: `SUCCESS - columns for table: ${selected.value} Found`,
      error: "FAILED - Please Reach out to Support for Assistance",
    };

    try {
      setExistingColumns([]); // Clear previous options
      setColumn("");
      const promise = apiRoot.get(
        `/api/fao-regime/columnnames/${schema}/${selected.value}`
      );
      const res = await toast.promise(promise, toastMessages);
      const newColumnOptions = res.data.map((item) => ({
        value: item[0],
        label: item[0],
        isDisabled: Boolean(
          columnOptions.find((option) => option.value === item[0])
        ),
      }));
      newColumnOptions.sort(compare);
      setExistingColumns(newColumnOptions); // Update state with new options
    } catch (error) {
      console.log(error);
    }
  };

  const handleColumnChange = (selected) => {
    setColumn(selected.value);
  };
  const addNewColumn = () => {
    const newColumn = {
      value: column,
      label: column,
      schema: schema,
      table: table,
    };
    setColumnOptions([...columnOptions, newColumn]);
    handlePopupClose();
  };
  const handlePopupClose = () => {
    setPopupOpen(false);
  };
  const renderSelect = (label, options, value, onChange) => {
    return (
      <CustomSelect
        label={label}
        id={label}
        options={options}
        labelInTop={true}
        required={true}
        customClass={mergeStyles(STYLES.label, "mb-2")}
        customSelectClass="h-10 w-full"
        extraStyles={() => ({
          ...customSelectStyles,
        })}
        isLoading={options.length === 0}
        disabled={options.length === 0}
        value={value}
        onChange={onChange}
        isSearchable={true}
      />
    );
  };
  return (
    <div className="fixed inset-0 z-[701] h-screen max-h-screen overflow-hidden">
      <div className="absolute inset-0 !bg-gray-07 opacity-60" />
      <div className="absolute left-1/2 top-2/4 -translate-x-1/2 -translate-y-1/2">
        <div className="flex w-full flex-shrink flex-col justify-between overflow-hidden rounded-md bg-white p-8">
          <Heading
            variant="h1"
            customClass="mobile:text-center tablet:text-left"
          >
            Add a new column
          </Heading>
          {renderSelect("Schema", SCHEMA_OPTIONS, schema, handleSchemaChange)}
          {renderSelect("Table", tableOptions, table, handleTableChange)}
          {renderSelect("Column", existingColumns, column, handleColumnChange)}
          <div className="mt-6 flex justify-end space-y-2 mobile:flex-col-reverse tablet:flex-row tablet:space-y-0">
            <CustomButton onClick={handlePopupClose}>Cancel</CustomButton>
            <CustomButton
              variant="primary"
              type="submit"
              disabled={!schema || !table || !column}
              onClick={addNewColumn}
            >
              Add
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegimeNewColumn;
